import * as types from './types'
import { listMessages as listMessagesRequest, updateMessageStatus } from '@cbgms/api/modules/messages/requests'
import { IPaginatedRequest } from '@cbgms/api/request'
import { StatusType } from '@cbgms/api/modules/messages'

export const loadSystemMessages = (params?: IPaginatedRequest) => ({
  type: [types.LOAD_SYSTEM_MESSAGES, types.LOAD_SYSTEM_MESSAGES_SUCCESS, types.LOAD_SYSTEM_MESSAGES_FAILED],
  payload: {
    api: 'gms',
    request: listMessagesRequest(params)
  }
})

export const putMessageStatus = (messageUUID: string, status: StatusType) => ({
  type: [types.PUT_SYSTEM_MESSAGE_STATUS, types.PUT_SYSTEM_MESSAGE_STATUS_SUCCESS, types.PUT_SYSTEM_MESSAGE_STATUS_FAILED],
  payload: {
    api: 'gms',
    request: updateMessageStatus(messageUUID, { Status: status })
  }
})
